

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { R6Map } from '@/maps';
import FloorLayer from '@/maps/FloorLayer';

@Component({
  components: {}
})
export default class LayerControl extends Vue {
  @Prop() public readonly layer!: FloorLayer;
  private isOpen = false;

  private sublayers = [];

  public get enabled() {
    return this.layer.config.enabled;
  }
  public set enabled(value: boolean) {
    this.layer.config.enabled = value;
  }
  public get alpha() {
    return this.layer.config.opacity * 100;
  }
  public set alpha(value: number) {
    this.layer.config.opacity = value / 100;
  }
  public get draggable() {
    return this.layer.config.draggable;
  }
  public set draggable(value: boolean) {
    this.layer.config.draggable = value;
  }

  public resetOffset() {
    this.layer.config.position = { x: 0, y: 0 };
  }

  public solo() {
    this.draggable = false;
    this.$emit('solo', this.layer);
  }
  public soloDrag() {
    this.$emit('solo-drag', this.layer);
  }
}
